import { render } from "./WizardStep.vue?vue&type=template&id=15d98580"
import script from "./WizardStep.vue?vue&type=script&lang=js"
export * from "./WizardStep.vue?vue&type=script&lang=js"
script.render = render

export default script